const footerPk = {
	company: 'گرامین بازار',
	description: 'بنگلہ دیش کی سب سے بڑی آن لائن مارکیٹ پلیس۔ روزمرہ کی ہر ضرورت یہاں دستیاب ہے۔',
	links: {
		company: 'کمپنی',
		business: 'بزنس',
		support: 'سپورٹ',
		about: 'ہمارے بارے میں',
		career: 'کیریئر',
		contact: 'رابطہ',
		help: 'مدد',
		becomeSeller: 'سیلر بنیں',
		businessAccount: 'بزنس اکاؤنٹ',
		marketplacePolicy: 'مارکیٹ پلیس پالیسی',
		deliveryPolicy: 'ڈیلیوری پالیسی',
		returnPolicy: 'ریٹرن پالیسی',
		privacyPolicy: 'پرائیویسی پالیسی',
	},
	contact: {
		heading: 'رابطہ',
		address: 'گھر #123، روڈ #45، بانانی، ڈھاکہ-1213',
	},
	copyright: (year) => `© ${year} گرامین بازار۔ جملہ حقوق محفوظ ہیں۔`,
};

export default footerPk;


